import { CompanyProperties, RelationIndustry } from '@/infrastructure/network/Monitaro/schema/models'

export interface ICompanyProps {
  id?: string
  industries: RelationIndustry[]
  priceId?: string | null
  name: string | null
  kana: string | null
  isChargeable: boolean | null
  createdAt: string | null
  updatedAt: string | null
  properties: CompanyProperties | null
  usersCount?: number
}

export interface ICompanyQueryProps {
  status?: string | null
  industries: string[] | null
}

export default class CompanyEntity {
  private _props: ICompanyProps

  constructor(props?: ICompanyProps | null) {
    this._props = EmptyCompanyPropsFactory(props)
  }

  get props(): ICompanyProps {
    return this._props
  }

  get clone(): ICompanyProps {
    return JSON.parse(JSON.stringify(this._props))
  }

  get id(): string | undefined {
    return this._props.id
  }

  get industries(): RelationIndustry[] | undefined {
    return this._props.industries
  }

  get name(): string | null {
    return this._props.name
  }

  get kana(): string | null {
    return this._props.kana
  }

  get isChargeable(): boolean | null {
    return this._props.isChargeable
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }

  get properties(): CompanyProperties | null | undefined {
    return this._props.properties
  }

  get usersCount(): number | undefined {
    return this._props.usersCount
  }
}

export const headers = [
  // { text: 'ID', value: 'id' },
  { text: '企業名', value: 'name' },
  { text: '他院の登録人数(延人数)', value: 'users_count', class: 'text-right' },
  { text: '業種', value: 'industries' }
]

export const EmptyCompanyQueryPropsFactory = (props?: Partial<ICompanyQueryProps> | null): ICompanyQueryProps => ({
  status: null,
  industries: null,
  ...props
})

export const EmptyCompanyPropsFactory = (props?: Partial<ICompanyProps> | null): ICompanyProps => ({
  industries: [],
  name: null,
  kana: null,
  properties: {},
  isChargeable: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
